import { defaultHttpClient } from '../../httpClient';
import type { PostResetPasswordRequest } from './types';

/**
 * 비밀번호 찾기
 * access_code로 비밀번호를 재설정.
 * access_code 만료(존재하지 않는 접근코드) 시 404 반환.
 */
export const postResetPassword = (params: PostResetPasswordRequest) => {
  return defaultHttpClient
    .request<void>({
      method: 'POST',
      url: '/api/v2/members/reset_password/',
      data: params,
    })
    .then(result => result.data);
};
